import { useEffect, useState } from "react";
import './ad-container-horizontal.css';
import './ad-container-vertical.css';
import './ad-container-interview-session.css';
import { useScreen } from "../../contexts/screen.provider";

interface GoogleAdProps {
  className?: string
}

export const GoogleAd = ({ className }: GoogleAdProps) => {
  const { isDesktop, isTablet, isMobile } = useScreen();
  const [mobileAdBgImage, setMobileAdBgImage] = useState("");

  const mobileAdsfallbackImages = [
    "/ad_fallback_banners/ad_bg_mobile_001.png",
    "/ad_fallback_banners/ad_bg_mobile_002.png",
    "/ad_fallback_banners/ad_bg_mobile_003.png"
  ];



  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
    }
    const randomIndex = Math.floor(Math.random() * mobileAdsfallbackImages.length);
    setMobileAdBgImage(mobileAdsfallbackImages[randomIndex]);
  }, []);

  return (
    <>
      {isTablet && (
        <div
          className={`ad-container-horizontal`}
          style={{
            height: "auto !important"
          }}
        >
          <ins className="adsbygoogle"
            style={{ display: "block", height: "100%" }}
            data-ad-client="ca-pub-9176018929494610"
            data-ad-slot="1878075913"
            data-ad-format="horizontal"
            data-full-width-responsive="true">
          </ins>
        </div>
      )}
      {isMobile && (
        <div className={`${className || 'ad-container-horizontal'} `} >
          <ins
            className="adsbygoogle"
            style={{
              display: "block",
              backgroundImage: `url(${mobileAdBgImage})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'

            }}
            data-ad-format="fluid"
            data-ad-layout="in-feed"
            data-ad-layout-key="-6t+ed+2i-1n-4w"
            data-ad-client="ca-pub-9176018929494610"
            data-ad-slot="1878075913"
            data-full-width-responsive={className ? "false" : "true"}>
          </ins>
        </div>
      )}
      {isDesktop && (
        <div className="ad-container-vertical "
          style={{
            height: 'auto !important '
          }}
        >
          <ins className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-9176018929494610"
            data-ad-slot="5564563072"
            data-ad-format="auto"
            data-full-width-responsive="true">
          </ins>
        </div>
      )}
    </>
  );
};